import styled, { css } from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const StyledContainer = styled(Box)`
  ${breakpointsMedia({
    lg: css`
      &:before {
        content: '';
        grid-column: span 2;
        grid-row: span 2;
      }
    `,
  })}
`;

StyledContainer.displayName = 'StyledContainer';
